import * as types from 'types/call';

export const getPadSound = padName => ({
    type: types[`DIAL_PAD_SOUND_${padName}`]
});
